import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CreateChannelDialog = ({ open, onClose, onCreate, isCreating, onError }) => {
  const { t } = useTranslation("team");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);

  useEffect(() => {
    if (!open) {
      setName("");
      setDescription("");
      setIsPrivate(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!name.trim()) return;
    try {
      await onCreate({
        name: name.trim(),
        description: description.trim() || null,
        isPrivate,
      });
      onClose();
    } catch (err) {
      if (onError) onError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 0.5 }}>{t("createChannelTitle")}</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          pt: 1.5,
          px: 3,
          pb: 1,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {t("channelDescriptionHint")}
        </Typography>
        <TextField
          label={t("channelName")}
          placeholder={t("channelNameHint")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          fullWidth
          variant="outlined"
        />
        <TextField
          label={t("channelDescription")}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          minRows={2}
          fullWidth
          variant="outlined"
        />
        <FormControlLabel
          sx={{ ml: 0 }}
          control={
            <Checkbox checked={isPrivate} onChange={(e) => setIsPrivate(e.target.checked)} />
          }
          label={t("privateChannel")}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!name.trim() || isCreating}
          sx={{ textTransform: "none" }}
        >
          {t("create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateChannelDialog;
